import { render, staticRenderFns } from "./ProduceInfo.vue?vue&type=template&id=e28a5d6c&scoped=true&"
import script from "./ProduceInfo.vue?vue&type=script&lang=js&"
export * from "./ProduceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProduceInfo.vue?vue&type=style&index=0&id=e28a5d6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a5d6c",
  null
  
)

export default component.exports